module.exports = __webpack_public_path__ + "img/monarch-ui-icon_MODEL.a0fd8e11.png";